import { defineComponent, ref, Ref, computed, onMounted } from 'vue';

export default defineComponent({
    props: {
    },
    emits: [],
    setup: function (props, ctx) {
        return {
        };
    }
});

